import React, { Component } from 'react';
import { Button } from 'reactstrap';

class PossibleValuesClickableFilter extends Component {
  constructor(props) {
    super(props);
    const { filterStateMap, filterIndex } = props;
    const savedFilterState = filterStateMap[`filter_${filterIndex}`];
    this.state = {
      activeIndex: savedFilterState
        ? this.getActiveIndex(savedFilterState)
        : -1,
      options: [],
    };
  }
  componentDidMount() {
    const { getSuggestions } = this.props;
    getSuggestions().then(res => {
      const values = res.data;
      const options =
        values &&
        values.map(val => {
          return {
            value: val.filterValue,
            label:
              val.filterValue == 'NULL' ? 'Not Available' : val.filterValue,
            count: val.count,
          };
        });
      this.setState({ options });
    });
  }
  setActiveIndex(activeIndex) {
    this.setState({ activeIndex });
  }
  itemClicked(value, activeIndex, ev) {
    ev.preventDefault();
    const {
      onFilterChange,
      filter,
      filterIndex,
      onFiltersApplied,
    } = this.props;
    const filterConfig = {
      filter,
      filterIndex,
    };
    this.setActiveIndex(activeIndex);
    value != ''
      ? onFilterChange(filterConfig, [value])
      : onFilterChange(filterConfig, []);
    onFiltersApplied();
    return false;
  }
  getCount(value) {
    const { options } = this.state;
    let count = 0;
    for (let i = 0; i < options.length; i += 1) {
      if (options[i].value === value) {
        count = options[i].count;
        break;
      }
    }
    return count;
  }
  getActiveIndex(savedState) {
    const { filterBy } = savedState;
    const {
      filter: { possibleValues },
    } = this.props;
    let activeIndex = -1;
    possibleValues &&
      possibleValues.map((value, index) => {
        if (value === filterBy[0]) {
          activeIndex = index;
        }
      });
    return activeIndex;
  }
  render() {
    let { typeModelName, workflow, filter } = this.props;
    const { activeIndex } = this.state;
    const { possibleValues } = filter;
    if (possibleValues.indexOf('NULL') == -1) possibleValues.push('NULL');
    if (!typeModelName) {
      typeModelName = workflow.currentItem.typeModel.name;
    }
    return (
      <div className='d-flex rounded-4 possible-values-filter-wrapper align-items-center'>
        <Button
          color='link'
          onClick={this.itemClicked.bind(this, '', -1)}
          className={`possible-values-filter-item text-center h-100 ${
            activeIndex === -1 ? 'active' : ''
          }`}
        >
          <div className='d-flex h-100 justify-content-center align-items-center'>
            <div>All</div>
          </div>
        </Button>
        {possibleValues &&
          possibleValues.map((value, index) => {
            return (
              <Button
                key={index}
                color='link'
                onClick={this.itemClicked.bind(this, value, index)}
                className={`possible-values-filter-item h-100 ${
                  activeIndex === index ? 'active' : ''
                }`}
              >
                <div className='d-flex flex-column text-center'>
                  <div>{this.getCount(value)}</div>
                  <div>{value == 'NULL' ? 'Not Available' : value}</div>
                </div>
              </Button>
            );
          })}
      </div>
    );
  }
}

export default PossibleValuesClickableFilter;
